import {publicApi} from '../../global/api';

export const getDemoCaptcha = async (signal: AbortSignal) => {
  const params = {signal, headers: {'Cache-Control': 'no-cache, no-store'}};
  const {data}: {data: unknown} = await publicApi.captcha.getCaptcha(undefined, {...params, format: 'json'});

  // The first response is {captchaId}; only the request with that ID returns a PNG.
  const captchaId = data && typeof data === 'object' && 'captchaId' in data ? data.captchaId : undefined;
  if (typeof captchaId !== 'string' || !captchaId.trim()) {
    throw new Error('Не удалось получить идентификатор капчи');
  }

  const id = captchaId.trim();
  const {data: image} = await publicApi.captcha.getCaptcha({captchaId: id}, {...params, format: 'blob'});

  if (!(image instanceof Blob) || !image.size) {
    throw new Error('Не удалось получить изображение капчи');
  }

  return {id, image};
};
